import React from 'react';
import { Text } from '@cad-arc';

export function TabNoData(props: { children?: string }): React.ReactElement {
    return (
        <Text fontSize="sm" variant="bodyMd" color="placeholder">
            {props.children ? props.children : 'None'}
        </Text>
    );
}
